import Axios from "../../api/Axios";
const BASE_URL = "ColateralReallocation/";
export const EndpointCollateralReallocation = {
    GetDCforConfirmation: "GetDCforConfirmation",
    PopulateCustomer: "PopulateCustomer",
    ConfirmDeallocate: "ConfirmDeallocate",
    SaveDeallocate: "SaveDeallocate"
};
export const createAPICollateralReallocation = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };
};